import { Col, Row } from 'antd';
import { AInput, ARadioButton, ATitle } from '../../../../components';
import { currency } from '../../../../shared/utils/functions';

interface IDiscountProps {
  code: number | null;
  type_discount: number;
  setType_Discount: React.Dispatch<React.SetStateAction<number>>;
  total: number;
  setDiscount: React.Dispatch<React.SetStateAction<number>>;
  discount: number;
}

const Discount: React.FC<IDiscountProps> = ({
  code,
  type_discount,
  setType_Discount,
  total,
  setDiscount,
  discount,
}) => {
  return (
    <Row>
      {!code && (
        <>
          <Col span={3}>
            <ATitle level={5}>Desconto:</ATitle>
          </Col>
          <Col span={5}>
            <ARadioButton
              value={type_discount}
              onChange={(e) => setType_Discount(e.target.value)}
              options={[
                { label: 'Porcentagem', value: 0 },
                { label: 'Valor', value: 1 },
              ]}
            />
          </Col>
          <Col span={4}>
            <AInput
              value={discount}
              type="number"
              onChange={(e) => {
                if (+e.target.value >= 0) setDiscount(+e.target.value);
              }}
            />
          </Col>
        </>
      )}
      <Col
        span={code ? 18 : 6}
        style={{ display: 'flex', justifyContent: 'end' }}
      >
        <ATitle level={3}>Total</ATitle>
      </Col>
      <Col span={6} style={{ display: 'flex', justifyContent: 'end' }}>
        <ATitle level={3}>{currency(total)}</ATitle>
      </Col>
    </Row>
  );
};

export default Discount;
